export class Choujiang {
    chance;
    detail = {
        prizeList: new Array(8).fill(new Goods()),
        rule: "",
        type: "",
    };
    hasSub = false;
    canzhuli = false;
    isWx = false;
    tip = "";
    constructor() { }
}

export class Goods {
    goodsId;
    name;
    goodsCode;
    label;
    rank;
    id;
    constructor() { }
}


export class User {
    name;
    phone;
    address;

    constructor() { }
}